import {AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ConsultaService} from 'src/app/service/consulta/consulta.service';
import {DesmarcarOutrasOpcoesService} from 'src/app/service/util/desmarcar-outras-opcoes.service';
import {AuthService} from 'src/app/service/autenticacao/auth.service';
import {
  MSG_CONSULTA_SERVICO_NOTARIAL_NUMERO_INCORRETO,
  MSG_CONSULTA_SERVICO_NOTARIAL_NUMERO_INVALIDO
} from 'src/app/tools/Mensagens';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ServicoNotarialInfoDTO} from 'src/app/entity/ServicoNotarialInfoDTO';
import { RestituicaoFormComponent } from './partials/restituicao-form/restituicao-form.component';
import { RestituicaoRequest } from './partials/restituicao-form/restituicao-form.dto';
import { MonitoramentoConciliacaoFormComponent } from './partials/monitoramento-conciliacao-form/monitoramento-conciliacao-form.component';
import { MonitoramentoConciliacaoRequest } from './partials/monitoramento-conciliacao-form/monitoramento-conciliacao-form.dto';

const ID_CLASSIFICACAO_MONITORAMENTO_CONCILIACAO = 168;

declare var $: any;


@Component({
  selector: 'cartorios-extrajudicial-consulta',
  templateUrl: './cartorios-extrajudicial-consulta.component.html',
  styleUrls: ['./cartorios-extrajudicial-consulta.component.css']
})
export class CartoriosExtrajudicialConsultaComponent implements OnInit, AfterViewChecked {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  @Input() apenasCadastro = false;
  @ViewChild(RestituicaoFormComponent, { static: false }) restituicaoFormComponent: RestituicaoFormComponent;
  @ViewChild(MonitoramentoConciliacaoFormComponent, { static: false })
  monitoramentoConciliacaoFormComponent: MonitoramentoConciliacaoFormComponent;
  listaClassificacaoComponente = [];
  charNum = 5000;
  tipoClassificacaoSelecionado: any;
  mostrarDadosConciliadorRequerente: boolean = false;
  mostrarRestituicaoForm: boolean = false;
  mostrarMonitoramentoConciliacaoForm: boolean = false;
  tituloAnexarDocumentos = "Anexar documentos pessoais do(a) Requerente. Caso o(a) Requerente não seja o(a) responsável pela serventia, anexar a Portaria de Nomeação como Substituto(a).";
  listaConciliador: FormArray;
  quantidadeMaximaDadosMediadorConciliador: number = 5;
  tipoAtuacao: number = null;

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  constructor(
    public service: ConsultaService,
    private desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService,
    private cdRef: ChangeDetectorRef, // adicione isso
    private fb: FormBuilder) {
  }

  ngOnInit() {
    this.preencherListaClassificacao();
    //console.log(this.service.consulta);
    const selecionado = this.listaClassificacaoComponente.find(item => item.selecionado);
    if (selecionado) {
      this.checkClassificacaoUmRegistro(selecionado);
    }


    if (this.visualizacao || this.edicao) {
      this.tratarVisualizacaoOuEdicao();
    }

    if (!this.service.consulta.get('listaConciliador')) {
      this.listaConciliador = this.fb.array([]);
      this.service.consulta.addControl('listaConciliador', this.listaConciliador);
    } else {
      this.listaConciliador = this.service.consulta.get('listaConciliador') as FormArray;
    }
  }

  ngAfterViewChecked() {
    if (typeof $().tooltip === 'function') {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }

  adicionarConciliador() {
    let validacaoConciliador = this.formularioConciliadorInvalido();
    let validacaoRequerente = this.formularioRequerenteInvalido();

    if (validacaoConciliador) {
      alert('Por favor, preencha corretamente todos os dados do(a) conciliador(a)/mediador(a) atual antes de adicionar um novo.');
      return;
    }

    if (validacaoRequerente) {
      alert('Por favor, preencha todos os dados do(a) conciliador(a)/mediador(a) requerente antes de adicionar um novo.');
      return;
    }
    this.quantidadeMaximaDadosMediadorConciliador = this.obterQuantidadeMaximaDadosMediadorConciliador();
    console.log("Apenas cadastro: " + this.apenasCadastro);
    const arquivoDeveSerObrigatorio = this.apenasCadastro || (!this.edicao && !this.visualizacao);
    this.listaConciliador.push(this.service.criarConciliadorForm(arquivoDeveSerObrigatorio));
  }

  obterQuantidadeMaximaDadosMediadorConciliador(): number {
    const APENAS_REQUERENTE: number = 0;
    if (this.tipoAtuacao == APENAS_REQUERENTE) {
      return 5;
    } else {
      return 4;
    }
  }

  removerConciliador(idx: number) {
    if (this.listaConciliador.length > 0) {
      // Captura os valores atuais
      const valoresAtuais = this.listaConciliador.value.filter((_, index) => index !== idx);

      // Limpa completamente
      this.listaConciliador.clear();

      // Recria com os valores restantes
      valoresAtuais.forEach(valor => {
        const formGroup = this.service.criarConciliadorForm();
        formGroup.patchValue(valor);
        this.listaConciliador.push(formGroup);
      });

      // Atualiza
      this.listaConciliador.markAsDirty();
      this.listaConciliador.updateValueAndValidity();
    }
  }

  tratarVisualizacaoOuEdicao() {

    if (this.service.consulta.controls != null) {

      if (this.service.consulta.get("tipoClassificacao").value != null) {

        if (this.service.consulta.get("tipoClassificacao").value === "1") {
          this.tipoClassificacaoSelecionado = 1;
        } else if (this.service.consulta.get("tipoClassificacao").value === "2") {
          this.tipoClassificacaoSelecionado = 2;
        } else if (this.service.consulta.get("tipoClassificacao").value === "3") {
          this.tipoClassificacaoSelecionado = 3;
        }
      }
    }
  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.consulta.value.listaClassificacaoCompleta
      .filter(item => item.assunto.value === this.service.consulta.value.assunto.value);
  }

  // Método de check de classificação, quando se aceita a escolha de um registro ou mais
  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarOutrasOpcoes(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  checkClassificacaoUmRegistro(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
    this.mostrarDadosConciliadorParaCadadastroServentia(item.id);
    this.mostrarRestituicao(item.id);
    this.mostrarMonitoramentoConciliacao(item.id);
  }

  atribuirListaClassificacao() {
    this.service.consulta.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.consulta.controls[str].touched &&
      this.service.consulta.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

  buscaInformacoesServentia(codigoCNS) {

    if (codigoCNS != '') {

      if (this.isValidoCodigoCNS(codigoCNS)) {

        var codigoCNSFormatado = this.obterCodigoCNSFormatado(codigoCNS);
        var codigoCNSParametro = parseInt(this.obterCodigoCNSSemFormatacao(codigoCNS));

        this.service.buscarInformacoesServentia(codigoCNSParametro).subscribe((consulta: ServicoNotarialInfoDTO) => {

          if (!consulta) {
            this.limparCamposBuscaInformacoesServentia();
            alert(MSG_CONSULTA_SERVICO_NOTARIAL_NUMERO_INVALIDO);

          } else {

            this.service.consulta.controls.codigoCNS.setValue(codigoCNSParametro);
            this.service.consulta.controls.codigoCNSFormatado.setValue(codigoCNSFormatado);
            this.service.consulta.controls.nomeMunicipioServentia.setValue(consulta.nomeMunicipioServentia);
            this.service.consulta.controls.nomeResponsavelServentia.setValue(consulta.nomeResponsavelServentia);
            this.service.consulta.controls.nomeServentia.setValue(consulta.nomeServentia);
            this.service.consulta.controls.codigoMunicipioServentia.setValue(consulta.codigoMunicipioServentia);
            this.service.consulta.controls.codigoComarca.setValue(consulta.codigoComarca);

          }
        });

      } else {
        this.limparCamposBuscaInformacoesServentia();
        alert(MSG_CONSULTA_SERVICO_NOTARIAL_NUMERO_INCORRETO);
      }

    } else {
      this.limparCamposBuscaInformacoesServentia();
    }
  }

  mensagemCodigoCNSIncorreto() {
    return MSG_CONSULTA_SERVICO_NOTARIAL_NUMERO_INCORRETO;
  }

  mensagemCodigoCNSInvalido() {
    return MSG_CONSULTA_SERVICO_NOTARIAL_NUMERO_INVALIDO;
  }

  isValidoCodigoCNS(codigoCNS: string) {
    const regra = /^[0-9]*$/;
    var codigoCNSFormatado = this.obterCodigoCNSSemFormatacao(codigoCNS);

    if (codigoCNSFormatado != "" && codigoCNSFormatado.match(regra)) {
      return true;
    }

    return false;
  }

  obterCodigoCNSFormatado(codigoCNS: string) {

    var codigoCNSFormatado = this.obterCodigoCNSSemFormatacao(codigoCNS);
    codigoCNSFormatado = codigoCNSFormatado.padStart(6, '0');
    codigoCNSFormatado = codigoCNSFormatado.replace(/(\d{2})(\d{3})(\d{1})/g, '\$1.\$2\.\$3');

    return codigoCNSFormatado;
  }

  obterCodigoCNSSemFormatacao(codigoCNS: string) {
    return codigoCNS.trim().replace(/[^0-9]/g, '');
  }

  limparCamposBuscaInformacoesServentia() {
    this.service.consulta.controls.nomeMunicipioServentia.setValue("");
    this.service.consulta.controls.nomeServentia.setValue("");
    this.service.consulta.controls.nomeResponsavelServentia.setValue("");
  }

  mudaClassificacao(status) {
    const CLASSIFICACAO_REQUERIMENTO = 3;
    this.tipoClassificacaoSelecionado = status + '';
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoes(this.listaClassificacaoComponente);
    if (status !== CLASSIFICACAO_REQUERIMENTO) {
      this.mostrarDadosConciliadorRequerente = false;
      this.mostrarRestituicaoForm = false;
      this.mostrarMonitoramentoConciliacaoForm = false;
      this.cdRef.detectChanges();
      this.atualizarValidacaoDescricaoConsulta();
    }
  }

  private mostrarDadosConciliadorParaCadadastroServentia(id: number): void {
    if ((this.edicao || this.apenasCadastro) || (!this.visualizacao && !this.edicao)) {
      const ID_CLASSIFICACAO_CADASTRAMENTO_SERVENTIA = 155;
      this.mostrarDadosConciliadorRequerente = id === ID_CLASSIFICACAO_CADASTRAMENTO_SERVENTIA;
    }
  }

  private mostrarRestituicao(id: number): void {
    if ((this.edicao || this.apenasCadastro) || (!this.visualizacao && !this.edicao)) {
      const ID_CLASSIFICACAO_RESTITUICAO = 156;
      this.mostrarRestituicaoForm = id === ID_CLASSIFICACAO_RESTITUICAO;
      this.atualizarValidacaoDescricaoConsulta();
    }
  }

  /**
   * O formulário de monitoramento também é exibido na visualização (somente leitura),
   * para que o operador consulte os dados informados pela serventia.
   */
  private mostrarMonitoramentoConciliacao(id: number): void {
    this.mostrarMonitoramentoConciliacaoForm = id === ID_CLASSIFICACAO_MONITORAMENTO_CONCILIACAO;
    this.atualizarValidacaoDescricaoConsulta();
  }

  /**
   * Atualiza a validação do campo "descricaoConsulta":
   * - obrigatório normalmente;
   * - opcional quando for o requerimento de restituição (mostrarRestituicaoForm = true)
   *   ou o monitoramento de conciliação e mediação, em que o campo corresponde às observações.
   */
  private atualizarValidacaoDescricaoConsulta(): void {
    const descricaoControl = this.service.consulta.get('descricaoConsulta');
    if (!descricaoControl) {
      return;
    }

    if (this.mostrarRestituicaoForm || this.mostrarMonitoramentoConciliacaoForm) {
      descricaoControl.clearValidators();
    } else {
      descricaoControl.setValidators([Validators.required]);
    }

    descricaoControl.updateValueAndValidity({ emitEvent: false });
  }

  private formularioConciliadorInvalido() {
    let ultimoConciliadorForm: FormGroup;
    if (this.listaConciliador.length > 0) {
      ultimoConciliadorForm = this.listaConciliador.at(this.listaConciliador.length - 1) as FormGroup;
      ultimoConciliadorForm.markAllAsTouched();
      ultimoConciliadorForm.updateValueAndValidity();
      if (!ultimoConciliadorForm.valid) {
        return true;
      }
    }
    return false;
  }

  private formularioRequerenteInvalido() {
    if (this.listaConciliador.length < 1) {
      const dadosRequerenteForm = this.service.consulta.get('dadosRequerente') as FormGroup;
      dadosRequerenteForm.markAllAsTouched();
      dadosRequerenteForm.updateValueAndValidity();
      if (!dadosRequerenteForm.valid) {
        return true;
      }
    }
    return false;
  }

  obterTipoAtuacao(tipoAtuacao: number) {
    if (this.tipoAtuacao !== tipoAtuacao) {
      this.listaConciliador.clear();
      this.tipoAtuacao = tipoAtuacao;
    } else {
      this.tipoAtuacao = tipoAtuacao;
    }
  }

  obterRestituicaoPayloadSeValido(): RestituicaoRequest | null {
    if (!this.mostrarRestituicaoForm || !this.restituicaoFormComponent) {
      return null;
    }

    return this.restituicaoFormComponent.getRestituicaoPayloadIfValid();
  }

  /**
   * Retorna o payload do monitoramento já validado, ou null caso o formulário
   * esteja inválido ou não esteja visível.
   */
  obterMonitoramentoConciliacaoPayloadSeValido(): MonitoramentoConciliacaoRequest | null {
    if (!this.mostrarMonitoramentoConciliacaoForm || !this.monitoramentoConciliacaoFormComponent) {
      return null;
    }

    return this.monitoramentoConciliacaoFormComponent.getMonitoramentoPayloadIfValid();
  }

  get consultaFiltrada() {
    const v = this.service.consulta.value;

    return {
      id: v.id,
      //files: v.files,
      username: v.username,
      dataHoraAbertura: v.dataHoraAbertura,
      nome: v.nome,
      email: v.email,
      descricaoConsulta: v.descricaoConsulta,
      codigoCNS: v.codigoCNS,
      codigoCNSFormatado: v.codigoCNSFormatado,
      nomeResponsavelServentia: v.nomeResponsavelServentia,
      nomeMunicipioServentia: v.nomeMunicipioServentia,
      nomeServentia: v.nomeServentia,
      codigoMunicipioServentia: v.codigoMunicipioServentia,
      tipoClassificacao: v.tipoClassificacao,
      codigoComarca: v.codigoComarca,
      demandaRecebida: v.demandaRecebida,
      dadosRequerente: v.dadosRequerente,
      listaConciliador: v.listaConciliador,
      termoDeclaracaoVerdade: v.termoDeclaracaoVerdade,
      monitoramentoConciliacao: v.monitoramentoConciliacao
    };
  }

  getInvalidControlsList() {
    const invalid = [];
    const controls = this.service.consulta.controls;

    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push({
          campo: name,
          erros: controls[name].errors,
          valor: controls[name].value
        });
      }
    }

    return invalid;
  }

  protected readonly Object = Object;
}
